import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";

export class POSTMentorStudentRequest {
    public id: string | null = null;
    public rotaId: Guid = "";
    public mentorId: Guid = "";
    public startDate?: Date | string;
    public pickUpAddressId?: string;
    public dropOffAddressId?: string;
    public startTime: string = "";
    public endTime: string = "";
    [key: string]: any;
}

export class POSTMentorStudentEndPoint extends Endpoint<POSTMentorStudentRequest, Response> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.WeeklyRota.SaveMentorStudentRota);
    }

    public async HandleRequestAsync(request: POSTMentorStudentRequest): Promise<POSTMentorStudentRequest> {
        return request;
    }

    public async HandleResponseAsync(response: any): Promise<any> {
        return response;
    }
}
